import { useCallback, useState } from 'react';

const KEY = 'gita-progress';

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    return new Set(raw ? JSON.parse(raw) : []);
  } catch {
    return new Set();
  }
}

function write(set) {
  try {
    localStorage.setItem(KEY, JSON.stringify([...set]));
  } catch {}
}

export function useReadingProgress() {
  const [readVerses, setReadVerses] = useState(read);

  const markRead = useCallback((chapterNumber, slokaNumber) => {
    const key = `${chapterNumber}:${slokaNumber}`;
    setReadVerses((prev) => {
      if (prev.has(key)) return prev;
      const next = new Set(prev);
      next.add(key);
      write(next);
      return next;
    });
  }, []);

  const isRead = useCallback(
    (chapterNumber, slokaNumber) => readVerses.has(`${chapterNumber}:${slokaNumber}`),
    [readVerses]
  );

  const getChapterProgress = useCallback(
    (chapterNumber, verseCount) => {
      if (!verseCount) return 0;
      let count = 0;
      for (let i = 1; i <= verseCount; i++) {
        if (readVerses.has(`${chapterNumber}:${i}`)) count++;
      }
      return count / verseCount;
    },
    [readVerses]
  );

  return { readVerses, markRead, isRead, getChapterProgress };
}
